import { recordPackageProtectionPriceExposure } from "@redotech/shopify-sdk/rpc/schema/package-protection/record-package-protection-price-exposure";
import { memo, useContext, useEffect } from "react";
import { RedoShopifyRpcClientContext } from "../client/redo-shopify-rpc-client";
import { RedoEmittedDomEvent } from "../dom-events";
import { log } from "../monitoring/log";
import { type PackageProtectionExposurePayload } from "../utils/package-protection-exposure";

export const PackageProtectionExposureTracker = memo(
  function PackageProtectionExposureTracker() {
    const rpcClient = useContext(RedoShopifyRpcClientContext);

    useEffect(() => {
      if (!rpcClient) {
        return;
      }

      const handler = (event: Event) => {
        const payload = (event as CustomEvent<PackageProtectionExposurePayload>)
          .detail;
        rpcClient(recordPackageProtectionPriceExposure, payload).catch(
          (error) => {
            log("Error sending package protection exposure event", error, {
              modelVersionId: payload.modelVersionId,
              betaSampleIndex: payload.betaSampleIndex,
              cartHash: payload.cartHash,
            });
          },
        );
      };

      window.addEventListener(
        RedoEmittedDomEvent.PackageProtectionExposure,
        handler,
      );
      return () => {
        window.removeEventListener(
          RedoEmittedDomEvent.PackageProtectionExposure,
          handler,
        );
      };
    }, [rpcClient]);

    return null;
  },
);
